import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";
import "./i18n";
import { ResultPage } from "./components";
import AfterQuizRouter from "./components/AfterQuiz";
import ThankYouCard from "./components/ThankYouCard";
import OpenAIBot from "./components/OpenAIBot";
import USScreeningPrograms from "./components/USScreeningPrograms";
import MultiPageSurvey from "./components/MultiPageSurvey";
import LandingPage from "./components/LandingPage";
import HealthTips from "./components/HealthTips";
import PrivacyPolicy from "./components/PrivacyPolicy";
import AuditPage from "./components/AuditPage";
import FeatureVotePage from "./components/FeatureVotePage";
import DemoResultPage from "./components/DemoResultPage";
import ResultPageV2 from "./components/ResultPageV2";
import DemoResultPageV2 from "./components/DemoResultPageV2";
import ResultPageV3 from "./components/ResultPageV3";
import ResultPageV4 from "./components/ResultPageV4";
import ResultPageV5 from "./components/ResultPageV5";
import EnergyLandingPage from "./components/energy/EnergyLandingPage";
import EnergyMultiPageSurvey from "./components/energy/EnergyMultiPageSurvey";
import EnergyResultPage from "./components/energy/EnergyResultPage";
import FEATURE_FLAGS from "./config/featureFlags";

// Main App component with React Router v6
function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Analytics />
      <div className="App">
        <Routes>
          {/* Landing Page */}
          <Route path="/landing" element={<LandingPage />} />
          
          {/* After Quiz Flow */}
          <Route path="/after-quiz/*" element={<AfterQuizRouter />} />
          
          {/* Home Page - redirect to landing page */}
          <Route path="/" element={<Navigate to="/landing" replace />} />
          
          {/* Privacy Policy */}
          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* Energy Quiz Flow */}
          <Route path="/energy" element={<EnergyLandingPage />} />
          <Route path="/energy/quiz/*" element={<EnergyMultiPageSurvey />} />
          <Route path="/energy/results" element={<EnergyResultPage />} />

          {/* Survey Flow */}
          <Route path="/survey/*" element={<MultiPageSurvey />} />
          
          {/* Feature Vote (between survey and results) */}
          <Route path="/vote" element={<FeatureVotePage />} />

          {/* Results Page */}
          <Route path="/results" element={<ResultPage />} />
          
          {/* Demo Results (shareable) */}
          <Route path="/demo" element={<DemoResultPage />} />
          
          {/* Results V2 (new design) */}
          <Route path="/results-v2" element={<ResultPageV2 />} />
          <Route path="/demo-v2" element={<DemoResultPageV2 />} />
          <Route path="/results-v3" element={<ResultPageV3 />} />
          <Route path="/results-v4" element={<ResultPageV4 />} />
          <Route path="/results-v5" element={<ResultPageV5 />} />
          
          {/* Additional Pages */}
          <Route path="/thankyou" element={<ThankYouCard />} />
          <Route path="/openai" element={<OpenAIBot />} />
          <Route path="/programs" element={<USScreeningPrograms />} />
          <Route path="/health-tips" element={<HealthTips />} />
          
          {/* Audit Page (dev only) */}
          {(FEATURE_FLAGS.RECOMMENDATION_AUDIT_PAGE || new URLSearchParams(window.location.search).get('audit') === 'true') && (
            <Route path="/audit" element={<AuditPage />} />
          )}
          
          {/* Fallback to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;